module.exports = __webpack_public_path__ + "static/MaxandMilofrontcover-14f650baa7594a638842c2146d79c11e.jpg";